import { AGENCY_HIRING_CONSTANT_MAPPING_AM } from "./agencyHiringConstantMapping-am";
import { AGENCY_HIRING_CONSTANT_MAPPING_JP } from "./agencyHiringConstantMapping-jp";
import { AGENCY_HIRING_CONSTANT_MAPPING_MENA } from "./agencyHiringConstantMapping-mena";

export type AgencyHiringConstantMapping = Record<string, string>;

export const AGENCY_HIRING_CONSTANT_MAPPING_MAP = new Map<
  string,
  AgencyHiringConstantMapping
>([
  ["beta-mena", AGENCY_HIRING_CONSTANT_MAPPING_MENA],
  ["gamma-mena", AGENCY_HIRING_CONSTANT_MAPPING_MENA],
  ["preprod-mena", AGENCY_HIRING_CONSTANT_MAPPING_MENA],
  ["prod-mena", AGENCY_HIRING_CONSTANT_MAPPING_MENA],
  ["beta-am", AGENCY_HIRING_CONSTANT_MAPPING_AM],
  ["gamma-am", AGENCY_HIRING_CONSTANT_MAPPING_AM],
  ["preprod-am", AGENCY_HIRING_CONSTANT_MAPPING_AM],
  ["prod-am", AGENCY_HIRING_CONSTANT_MAPPING_AM],
  ["beta-jp", AGENCY_HIRING_CONSTANT_MAPPING_JP],
  ["gamma-jp", AGENCY_HIRING_CONSTANT_MAPPING_JP],
  ["preprod-jp", AGENCY_HIRING_CONSTANT_MAPPING_JP],
  ["prod-jp", AGENCY_HIRING_CONSTANT_MAPPING_JP],
]);
